import React, { useCallback, useRef } from 'react';
import { IStaticElement } from 'shared/offerCalculator/types/calculator';
import { UIHeading4, IconChevronDown16, IconChevronUp16 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { selectDisplayAllFilters } from 'shared/offerCalculator/selectors';
import { setDisplayAllFilters } from 'shared/offerCalculator/redux';
import { debouncedClickMoreFiltersAnalyticsHandler } from 'shared/offerCalculator/utils';

export const MoreFiltersButton: React.FC<IStaticElement> = () => {
  const $btnRef = useRef<HTMLButtonElement>(null);
  const dispatch = useDispatch();
  const isAllFiltersVisible = useSelector(selectDisplayAllFilters);
  const analyticsMoreFiltersClickHandler = debouncedClickMoreFiltersAnalyticsHandler($btnRef?.current);
  const handler = useCallback(() => {
    dispatch(setDisplayAllFilters(!isAllFiltersVisible));
    analyticsMoreFiltersClickHandler();
  }, [dispatch, analyticsMoreFiltersClickHandler, isAllFiltersVisible]);

  return (
    <button ref={$btnRef} className={styles.root} type="button" onClick={handler} data-testid="form-feature-button">
      <UIHeading4 color="primary_100">Ещё фильтры</UIHeading4>
      {isAllFiltersVisible ? <IconChevronUp16 color="primary_100" /> : <IconChevronDown16 color="primary_100" />}
    </button>
  );
};
